import { render, staticRenderFns } from "./ControlPanelItem.vue?vue&type=template&id=ecd4fa86&scoped=true&"
import script from "./ControlPanelItem.vue?vue&type=script&lang=js&"
export * from "./ControlPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelItem.vue?vue&type=style&index=0&id=ecd4fa86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd4fa86",
  null
  
)

export default component.exports